class e{constructor(e,t){t?(this.key=t.keyCode,this.element=t.target,this.event=t):(this.key=null,this.element=null,this.event=null)}}export{e as KeyboardEvent};
